"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _agGridVue = require("./dist/agGridVue");

Object.defineProperty(exports, "AgGridVue", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_agGridVue).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid-vue/main.js
// module id = Ku5W
// module chunks = 0